var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnArrowNarrowShortUp = function SvgIcnArrowNarrowShortUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32247 9.70679C6.11599 9.51926 6 9.26495 6 8.99979C6 8.73462 6.11599 8.48031 6.32247 8.29279L10.728 4.29279C10.9345 4.10532 11.2146 4 11.5066 4C11.7987 4 12.0788 4.10532 12.2853 4.29279L16.6908 8.29279C16.8915 8.48139 17.0025 8.73399 17 8.99619C16.9974 9.25838 16.8816 9.5092 16.6774 9.6946C16.4732 9.88001 16.197 9.98518 15.9082 9.98746C15.6194 9.98974 15.3412 9.88894 15.1335 9.70679L12.608 7.41379V14.9998C12.608 15.265 12.492 15.5194 12.2854 15.7069C12.0789 15.8944 11.7988 15.9998 11.5066 15.9998C11.2145 15.9998 10.9344 15.8944 10.7279 15.7069C10.5213 15.5194 10.4053 15.265 10.4053 14.9998V7.41379L7.87981 9.70679C7.67328 9.89426 7.39319 9.99957 7.10114 9.99957C6.8091 9.99957 6.52901 9.89426 6.32247 9.70679Z",
    fill: "#24CA8E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnArrowNarrowShortUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_arrow_narrow_short_up.3ebcac31.svg";
export { ForwardRef as ReactComponent };